import { useEffect, useRef } from "react";

export function useClickOutSide(refs = [], onClickOutside) {
  const clickedInsideRef = useRef(false);

  useEffect(() => {
    let timeoutId;

    function handleMouseDown(e) {
      // 클릭이 내부에서 시작됐는지 기록
      const validRefs = refs.filter((ref) => ref?.current);
      clickedInsideRef.current = validRefs.some((ref) =>
        ref.current.contains(e.target)
      );
    }

    function handleClick(e) {
      const validRefs = refs.filter((ref) => ref?.current);
      if (validRefs.length === 0) return;

      const isOutside = validRefs.every(
        (ref) => !ref.current.contains(e.target)
      );

      // 내부 클릭 후 바깥 hover만 된 경우는 무시
      if (clickedInsideRef.current) {
        clickedInsideRef.current = false;
        return;
      }

      if (isOutside) onClickOutside?.(e);
    }

    // ✅ 기존 로직 유지 — 다음 루프에 등록
    timeoutId = setTimeout(() => {
      document.addEventListener("mousedown", handleMouseDown);
      document.addEventListener("click", handleClick);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("click", handleClick);
    };
  }, [refs, onClickOutside]);
}
